// Component: scroll reveal — one-time on-enter animation via IntersectionObserver.
//
// Fail-safe by construction: this file's FIRST act is to add .js-reveal to
// <html>, which is the only thing that hides .reveal targets (see hd-reveal.css).
// If the file never loads or throws, nothing is ever hidden. It loads in <head>
// without defer so the gate is set before paint (every target is below the fold,
// but this keeps tall viewports flash-free too); observer wiring waits for the DOM.
//
// Under prefers-reduced-motion or a browser without IntersectionObserver, it
// reveals everything immediately (drops the gate) and does no more.
//
// On first intersection each target gets .is-in (animating opacity 0->1,
// translateY 28px->0), is unobserved (one-time), then has its reveal classes
// stripped once the transition ends — so no residual transform lingers to fight
// the product-card hover lift.
(function () {
  "use strict";

  var root = document.documentElement;
  root.classList.add("js-reveal");

  function revealAll() {
    root.classList.remove("js-reveal");
  }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (!("IntersectionObserver" in window) || reduced.matches) {
    revealAll();
    return;
  }

  // strip .reveal/.is-in once the entry transition finishes (or a fallback
  // timeout), leaving the element in its natural, hover-ready state. No
  // propertyName filter: opacity and transform share a duration, so cleaning on
  // whichever transitionend fires first is visually seamless.
  function clean(el) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.removeEventListener("transitionend", finish);
      el.classList.remove("reveal", "is-in");
    }
    el.addEventListener("transitionend", finish, { once: true });
    // duration + max stagger delay + margin; covers interrupted/never-fired
    setTimeout(finish, 900);
  }

  function wire() {
    try {
      var targets = document.querySelectorAll(".reveal");
      if (!targets.length) return;

      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            obs.unobserve(el);
            el.classList.add("is-in");
            clean(el);
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -5% 0px" }
      );

      targets.forEach(function (el) {
        io.observe(el);
      });
    } catch (err) {
      // anything unexpected: never leave content hidden
      revealAll();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wire);
  } else {
    wire();
  }
})();
